import React from 'react'

import { Table } from 'antd'

import {
  baseUnitRender,
  categoryRender,
  deadlineAtRender,
  languageTypeRender,
  statusRender
} from '../../../components/table/fields/task'

const Tasks = (props) => {
  const columns = () => {
    const __columns = [
      { title: '#', dataIndex: 'code', key: 'order', width: 50 },
      { title: 'Service', dataIndex: 'name', key: 'name' },
      {
        title: 'Category',
        dataIndex: 'category',
        key: 'category',
        render: categoryRender
      },
      {
        title: 'Language(s)',
        dataIndex: 'language_type',
        key: 'languageType',
        render: languageTypeRender
      },
      {
        title: 'Unit',
        dataIndex: 'base_unit',
        key: 'unit',
        render: baseUnitRender
      },
      {
        title: 'Status',
        dataIndex: 'status',
        key: 'status',
        render: statusRender
      },
      {
        title: 'Deadline',
        dataIndex: 'deadline_at',
        key: 'deadlineAt',
        render: deadlineAtRender
      }
    ]

    return __columns
  }

  return (
    <>
      <Table
        rowKey={(row) => row.id}
        size='small'
        className='components-table-demo-nested'
        columns={columns()}
        dataSource={[props.task]}
        pagination={false}
      />
    </>
  )
}

export default Tasks
